import React from "react";
import styles from "./styles.m.css";
import PropTypes from "prop-types";
import { GA } from "../../../integrations";
import { PAGE_TYPE } from "../../../constants";

const ProgressBar = ({ bgcolor, progress, image }) => {
  const Parentdiv = {
    height: 100,
    backgroundColor: "white",
    borderRadius: 50
  };

  const Childdiv = {
    height: "100%",
    width: `${progress}%`,
    backgroundColor: bgcolor,
    borderRadius: 50,
    textAlign: "right"
  };

  const progresstext = {
    padding: 10,
    color: bgcolor,
    fontWeight: 900
  };

  return (
    <div style={Parentdiv} className={styles["progress-wrapper"]}>
      <div style={Childdiv} className={styles["progress"]}>
        <img src={image} alt="" className={styles["progress-image"]} />
        <span style={progresstext} className={styles["progress-text"]}>{`${progress}%`}</span>
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  bgcolor: PropTypes.string,
  progress: PropTypes.number,
  image: PropTypes.string
};

export class RaaguKedhuStaticPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zodiacs: [
        {
          title: "மேஷம்",
          titleshort: "மேஷ",
          score: 85,
          slogan: "தொட்டதெல்லாம் வெற்றி!",
          image: "https://media.vikatan.com/vikatan/2021-07/3c73071b-24f1-4201-aa7a-d5afe3527717/01_mesham.png",
          color: "#359a0b"
        },
        {
          title: "ரிஷபம்",
          titleshort: "ரிஷப",
          score: 72,
          slogan: "செலவுகள் குறையும்",
          image: "https://media.vikatan.com/vikatan/2021-07/52fe7d74-49d6-4c40-90c6-3a6922664a40/02_rishabam.png",
          color: "#f58426"
        },
        {
          title: "மிதுனம்",
          titleshort: "மிதுன",
          score: 77,
          slogan: "இனி எல்லாம் சுபமே!",
          image: "https://media.vikatan.com/vikatan/2021-07/ee73ab5b-e1c7-4f25-90d9-a8735dabbc95/03_medhunam.png",
          color: "#359a0b"
        },
        {
          title: "கடகம்",
          titleshort: "கடக",
          score: 69,
          slogan: "உழைத்தால் உயர்வு நிச்சயம்! ",
          image: "https://media.vikatan.com/vikatan/2021-07/01506f0b-f8ec-4e4c-aef9-3688846ba70a/04_kadakam.png",
          color: "#f58426"
        },
        {
          title: "சிம்மம்",
          titleshort: "சிம்ம",
          score: 55,
          slogan: "நா காக்க!",
          image: "https://media.vikatan.com/vikatan/2021-07/f3d97800-471c-43fe-aa50-dd8bdf4515e6/05_simmam.png",
          color: "#f90425"
        },
        {
          title: "கன்னி",
          titleshort: "கன்னி ",
          score: 60,
          slogan: "விட்டுக்கொடுத்தால் வெற்றி நிச்சயம்!",
          image: "https://media.vikatan.com/vikatan/2021-07/f1902ca8-4b3b-4616-a5b2-25b4813fe237/06_kanni.png",
          color: "#f90425"
        },
        {
          title: "துலாம்",
          titleshort: "துலாம்",
          score: 71,
          slogan: "பிரச்னைகள் விலகும் காலம்!",
          image: "https://media.vikatan.com/vikatan/2021-07/59864243-1ce8-4ea5-b7e3-3baf1f432092/07_dulam.png",
          color: "#f58426"
        },
        {
          title: "விருச்சிகம்",
          titleshort: "விருச்சிக",
          score: 75,
          slogan: "வெற்றிக்கொடிகட்டு!",
          image: "https://media.vikatan.com/vikatan/2021-07/1ea78197-ce9e-4972-be02-024a67d85b02/08_viruchagam.png",
          color: "#359a0b"
        },
        {
          title: "தனுசு",
          titleshort: "தனுசு",
          score: 61,
          slogan: "படிப்படியான முன்னேற்றம்!",
          image: "https://media.vikatan.com/vikatan/2021-07/1f34b79e-3968-4261-8cec-5b54d7a8a370/09_thausu.png",
          color: "#f90425"
        },
        {
          title: "மகரம்",
          titleshort: "மகர",
          score: 79,
          slogan: "ஜெயித்துக்காட்டும் நேரம்!",
          image: "https://media.vikatan.com/vikatan/2021-07/a26c71ac-4b59-4eb4-b543-1070fd289300/10_magaram.png",
          color: "#359a0b"
        },
        {
          title: "கும்பம்",
          titleshort: "கும்ப",
          score: 59,
          slogan: "செலவுகளில் சிக்கனம் தேவை!",
          image: "https://media.vikatan.com/vikatan/2021-07/30b4c36f-e326-4d54-aa96-5a72a3bbd449/11_kumbam.png",
          color: "#f90425"
        },
        {
          title: "மீனம்",
          titleshort: "மீன",
          score: 51,
          slogan: "விவாதங்கள் தவிர்த்தால் வெற்றி!",
          image: "https://media.vikatan.com/vikatan/2021-07/aaf1130d-bfa5-498d-9557-d9317bd5aa3b/12_meenam.png",
          color: "#f90425"
        }
      ],
      CurrentIndex: 0
    };
    this.outerarticle = React.createRef();
  }

  componentDidMount() {
    GA.registerPageView(PAGE_TYPE.RAAGUKEDHUPEYARCHI_STATIC, {});
  }

  setView = (action = false) => {
    if (action === true) {
      window.scrollTo({
        top: this.outerarticle.current.offsetTop + this.outerarticle.current.offsetHeight - 100,
        behavior: "smooth"
      });
    }
  };

  render() {
    return (
      <div className={`${styles["gurupayrchi-wrapper"]} container`}>
        <div className={styles["raasipalan-wrapper"]}>
          <div className={styles["banner-img"]}>
            <img
              src="https://media.vikatan.com/vikatan/2023-10/47a0c10f-248b-42f1-b4f0-4fc7b6a1926e/Rahu_ketu_peyarchi_palangal_2023_25.png"
              alt=""
              className={styles["image"]}
            />
            <h1>
              உங்கள் ராசிக்கு ராகு-கேது பெயர்ச்சிப் பலன் எப்படி?
              <span>ஸ்கோரை அறிய ராசியை க்ளிக் செய்யுங்கள்!</span>
            </h1>
          </div>
          <ul className={styles["raasi-grid"]} ref={this.outerarticle}>
            {this.state.zodiacs.map((zodiac, index) => (
              <li
                key={index}
                onClick={() => {
                  this.setState({
                    CurrentIndex: index
                  });
                  this.setView(true);
                }}
              >
                <img src={zodiac.image} alt="" />
                <div className={styles["rassi-content"]}>
                  <h4 className={`${index === this.state.CurrentIndex ? styles["active"] : ""}`}>{zodiac.title}</h4>
                </div>
              </li>
            ))}
          </ul>
          <div className={styles["raasi-score-wrapper"]}>
            <h1>
              <span className={styles["zodiac-short"]}>
                {this.state.zodiacs[this.state.CurrentIndex].titleshort} ராசிக்காரர்களே... !
              </span>
              <span className={styles["desc"]}>{this.state.zodiacs[this.state.CurrentIndex].slogan}</span>
            </h1>
            <ProgressBar
              bgcolor={this.state.zodiacs[this.state.CurrentIndex].color}
              progress={this.state.zodiacs[this.state.CurrentIndex].score}
              image={this.state.zodiacs[this.state.CurrentIndex].image}
            />
          </div>
          <h5 className={styles["other-text"]}>
            உங்களுக்கும், உங்கள் குடும்பத்தினருக்கும் முழுமையான ராகு-கேது பெயர்ச்சிப் பலன்களைத் தெரிந்துகொள்ள :
          </h5>

          <a
            className={styles["navigation"]}
            href="https://www.vikatan.com/collection/rahu-ketu-peyarchi-palangal-2023-by-kp-vidyadharan?utm_source=web&utm_medium=menu&utm_campaign=rahuketu"
            onClick={() => {
              if ("ga" in window) {
                window.ga("send", "event", "raagu-kedhu-web", "click", window.location.href);
              }
              if ("gtag" in window) {
                window.gtag("event", "raagu-kedhu-web", {
                  event_category: "click",
                  event_label: window.location.href
                });
              }
            }}
          >
            12 ராசிகளுக்குமான முழுப்பலன்களைக் காண
          </a>
        </div>
      </div>
    );
  }
}

export default RaaguKedhuStaticPage;
